import { render, staticRenderFns } from "./NEditor.vue?vue&type=template&id=55e2e7d0&scoped=true"
import script from "./NEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./NEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NEditor.vue?vue&type=style&index=1&id=55e2e7d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e2e7d0",
  null
  
)

export default component.exports